/* eslint-disable camelcase */
import { getUrlParams, getCookie } from '../../utils/common';
import { createPageEventObject } from '../../utils/metrics';
import { UnknownFunction, UnknownObject } from '../../utils/types';

/**
 * Recupera si el usuario es priority o no
 * @returns {object} res with two props subseg and priorityCheck
 */
type PriorityResult = {
  subseg: string;
  priorityCheck: boolean;
};
export const isPriority = (): PriorityResult => {
  let subseg = '';
  let priorityCheck = false;
  try {
    subseg = getCookie('subseg');
    if (subseg === 'R7') {
      priorityCheck = true;
    }
  } catch (e) {
    // Mandar errores
  }
  return {
    subseg,
    priorityCheck,
  };
};

/* NOOKINFO HELPERS */
export const QUEUE_NAMES = {
  GLOBAL: 'Context',
  CUSTO: 'Context-Custo-Params',
  TEST: 'Context-Custo-Test',
  PAGE: 'Context-Page-Params',
  // Cola para escribir testVersion desde CustomizerComponent
  CUSTO_TEST_VERSION: 'CUSTO_TEST_VERSION',
  // Cola para escuchar testVersion desde CustomizerComponent
  CUSTO_TEST_VERSION_RESULT: 'CUSTO_TEST_VERSION_RESULT',
  // ESta escucha los parametros que manda la pagina
  SEO_PARAMS: 'SEO_PARAMS',
  // Esta emite el seo ya solicitado
  SEO_DATA: 'SEO_DATA',
  // Evento para modificar caracteristica permitidas de context
  OPEN_CONTEXT_CHANGES: 'OPEN_CONTEXT_CHANGES',
};

export const mapContextParamsToPageEvent = (
  observerName: string,
  callBackNook: UnknownFunction,
): void => {
  let observer = observerName;
  if (!observer) {
    observer = `observer${Date.now()}`;
  }

  window.nookInfoExchange.registerAsObserver(
    QUEUE_NAMES.PAGE,
    observer,
    (message: UnknownObject) => {
      const object = createPageEventObject(message);
      if (typeof callBackNook === 'function') {
        callBackNook(object);
      }
    },
    false,
  );
};

export const getSeoInfoFromContext = (
  observerName: string,
  callBackNook: UnknownFunction,
): void => {
  let observer = observerName;
  if (!observer) {
    observer = `observer${Date.now()}`;
  }
  // TODOO
  window.nookInfoExchange.registerAsObserver(
    QUEUE_NAMES.SEO_DATA,
    observer,
    (seoData: UnknownObject) => {
      if (typeof callBackNook === 'function') {
        callBackNook(seoData);
      }
    },
  );
};

export const mapContextParamsToCustoReq = (
  observerName: string,
  callBackNook: UnknownFunction,
): void => {
  let observer = observerName;
  if (!observer) {
    observer = `observer${Date.now()}`;
  }
  window.nookInfoExchange.registerAsObserver(
    'Context-Custo-Params',
    observer,
    (message) => {
      try {
        if (message) {
          const urlParams = getUrlParams(true, [
            /recomEnterprise/g,
            /percentile/g,
            /levCode/g,
            /prodCode/g,
            /promoCode/g,
            /ctz_c/g,
            /turingDev/g,
            /productOffering/g,
            /webCode/g,
            /context.*/g,
            /custoHost/g,
            /businessClusters/g,
            /recomType/g,
            /userType/g,
            /ctzTest/g,
          ]);
          // Cuidado -> UserType es Legado/Telco/'' e infoRecom.userType es cliente-util/cliente-no-util.
          const {
            subseg,
            gwIspI3D,
            gwIsp,
            userType,
            clientIDs,
            device,
            i3Ready,
            pageSegment,
            userPriority,
            creativitiesHistory,
            referalAP,
            environment,
            infoRecom,
            userCUCFijoHash,
            userCUCMovilHash,
          } = message;
          let custoObject = {
            i3Ready,
            SEG_NAV: pageSegment,
            i3_cuc: userCUCFijoHash,
            i3_cucm: userCUCMovilHash,
            ga: clientIDs.ga,
            pageId: clientIDs.pageId,
            paid: clientIDs.sessId,
            ctz_c: 'true',
            originUrl: window.location.href,
            userType:
              infoRecom && infoRecom.userType ? infoRecom.userType : undefined,
            context: {
              subseg,
              creativitiesHistory,
              gw_isp: gwIsp,
              gw_isp_d: gwIspI3D,
              isLogado: userType ? 'true' : 'false',
              tipoUsuario: userType,
              deviceType: device,
              seg_nav: pageSegment,
              isPriority: userPriority ? 'true' : 'false',
              referal_ap: referalAP,
              environment,
              currentURL: environment.currentURL,
            },
          };

          if (urlParams.context && typeof urlParams.context === 'object') {
            urlParams.context = {
              ...custoObject.context,
              ...urlParams.context,
            };
          }
          custoObject = {
            ...custoObject,
            ...urlParams,
          };
          if (typeof callBackNook === 'function') {
            callBackNook(custoObject);
          }
        }
      } catch (e) {
        console.log(e);
        throw new Error(e);
      }
    },
    false,
  );
};

/**
 * Cierra sesión en Telco
 */

export const logoutTELCO = (url: string): null => {
  document.location.assign(url);
  return null;
};
/**
 * Cierra sesión de usuario.
 */
export const logoutConvergente = (url: string): void => {
  localStorage.removeItem('codigoOrden');
  localStorage.removeItem('numtlf');
  sessionStorage.removeItem('nameuser');
  sessionStorage.removeItem('urlhomeprivada');
  sessionStorage.removeItem('cclivr$$.api.misDatos');
  document.location.assign(url);
};


/**
 * Returns page segment
 * @return {string} 'particulares' by default
 */
export const getSegment = (): string => {
  let res = '';

  // intentamos por url empresas
  const { pathname } = window.location;
  if (pathname.indexOf('/empresas') === 0) {
    res = 'empresas';
  }

  // intentamos por url particulares
  if (
    pathname.indexOf('/particulares') === 0 ||
    pathname.indexOf('/cliente/areaprivada') === 0
  ) {
    res = 'particulares';
  }

  let cookieNav = null;
  try {
    cookieNav = getCookie('SEG_NAV');
  } catch (err) {
    cookieNav = null;
  }
  if (!res && cookieNav && cookieNav !== '' && cookieNav !== 'undefined') {
    res = cookieNav;
  }
  // en caso de no detectar por url, y en caso de que la cookie venga vacía
  if (!res) {
    res = 'particulares';
  }

  return res;
};
